var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.validationDiv},[(_vm.errors[0])?[_c('div',{staticClass:"input-error-msg"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.errors[0]))])])]:_vm._e(),_c('input',{attrs:{"type":"text","disabled":""},domProps:{"value":_vm.value}})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-exclamation-circle"})])
}]

export { render, staticRenderFns }